export default "/images/vendor/quill/icons/float-left.svg?917812e3f874fe7614bdc5302f157012";